export const miniExplorationUrl =
  "https://analytics.google.com/analytics/web/#/analysis/a122259245p559786795/edit/89d6QIyQRxa3QZe_kLgepQ";

export const analyticsReports = [
  {
    slug: "journey",
    title: "방문에서 생성·공유까지",
    tab: "핵심 여정 · 7단계 · 기간 내 사용자",
    description: "방문한 사용자가 근무표 생성과 공유까지 얼마나 이어지는지 확인합니다.",
    metrics:
      "방문 → 입력 → 생성 요청 → 생성 성공 → 소유자 결과 → 공유 링크 생성 → 전달·복사 성공의 단계별 사용자 수와 이탈을 봅니다.",
    reading:
      "기기별로 어느 단계에서 사용자 수가 줄어드는지 비교하세요. 선택한 기간 안의 사용자 흐름이며 동일 세션이나 30분 이내 전환을 뜻하지 않습니다.",
    limitation:
      "현재 운영은 입력 편집 이벤트를 수집하지 않습니다. 입력 단계가 포함된 닫힌 7단계 퍼널은 전체 방문자의 전환율 판단에 사용할 수 없습니다. 생성 요청·성공은 기능 활용 탭에서 함께 확인하세요.",
  },
  {
    slug: "results",
    title: "기존 결과의 재활용",
    tab: "결과 활용 · 열린 사용자 퍼널",
    description: "이미 만든 근무표를 다시 열고 공유하는 흐름을 확인합니다.",
    metrics: "소유자 결과 열람 → 공유 링크 생성 성공 → 전달·복사 성공의 사용자 수를 확인합니다.",
    reading:
      "새 생성 없이 기존 결과로 들어온 사용자도 포함하는 열린 퍼널입니다. 기기별 차이를 비교하고, 링크 생성 뒤 실제 복사·전달로 이어지는지 살펴보세요.",
    limitation:
      "공유 링크 생성과 전달 성공은 다른 행동입니다. 복사·전달 성공이 상대방의 실제 열람을 뜻하지는 않습니다.",
  },
  {
    slug: "features",
    title: "생성·공유 기능 이용",
    tab: "기능 활용 · 이벤트별 사용자와 횟수",
    description: "생성·공유 행동을 몇 명이 몇 번 이용했는지 확인합니다.",
    metrics: "이벤트 이름과 결과별 활성 사용자 수·이벤트 수를 기기별로 비교합니다.",
    reading:
      "생성 요청·생성 성공·공유 이벤트를 선택하고 결과를 성공·취소·실패로 나누어 읽으세요. 사용자 수는 이용한 사람의 규모, 이벤트 수는 행동의 반복 횟수입니다.",
    limitation:
      "운영은 방문·생성·공유 범위만 수집합니다. 도움말·입력 편집·개인 선택·최근 기록 관리의 빈 값은 미사용을 뜻하지 않습니다. 정확한 생성 건수는 내부 Duty 자동 생성 통계에서 확인하세요.",
  },
  {
    slug: "public-sharing",
    title: "공유받은 사람의 열람",
    tab: "공개 공유 · 수신자 도달과 접근 불가",
    description: "공유된 근무표가 실제로 열리는지, 접근할 수 없는 경우가 있는지 확인합니다.",
    metrics: "공개 공유 열람과 접근 불가 이벤트의 사용자 수·횟수를 기기별로 확인합니다.",
    reading:
      "공유 전달 지표와 나란히 보며 공개 열람의 추이를 확인하세요. 접근 불가가 늘면 공유 링크의 유효 상태와 서비스 상태를 점검하세요.",
    limitation:
      "생성자와 수신자를 같은 사용자로 연결하지 않습니다. 접근 불가는 만료·공유 중지·삭제 원인을 구분하지 않으며, 전달 대비 열람 수를 정확한 수신 전환율로 해석할 수 없습니다.",
  },
  {
    slug: "returning-users",
    title: "신규·재방문 이용 비교",
    tab: "기능 활용 · 신규와 재방문",
    description: "처음 방문한 사용자와 다시 방문한 사용자의 기능 이용을 비교합니다.",
    metrics: "신규·기존 사용자 분류별 생성·공유 이벤트의 활성 사용자 수와 이벤트 수를 확인합니다.",
    reading:
      "같은 기간에서 신규 사용자와 재방문 사용자의 생성·공유 행동을 비교하세요. 반복 방문자의 결과 활용이 늘어나는지 주간 추이를 살펴보세요.",
    limitation:
      "GA의 브라우저 기준 분류입니다. 동의 여부·쿠키 삭제·기기 변경에 영향을 받으므로 가입자 수나 정확한 재방문율과는 다릅니다.",
  },
  {
    slug: "acquisition",
    title: "첫 유입 매체별 이용",
    tab: "기능 활용 · 첫 유입 매체",
    description: "어떤 매체로 처음 들어온 사용자가 생성·공유 기능을 이용하는지 확인합니다.",
    metrics: "첫 사용자 매체별 활성 사용자 수와 생성·공유 이벤트 수를 확인합니다.",
    reading:
      "매체별 방문 규모와 기능 이용을 함께 비교하세요. 동일한 기간을 유지해 유입 캠페인 전후의 변화를 확인할 수 있습니다.",
    limitation:
      "첫 유입 기준이며 현재 세션의 유입 경로가 아닙니다. 허용된 유입 분류만 수집하므로 상세 캠페인이 other로 묶일 수 있습니다.",
  },
];
